import { bootstrap } from './bootstrap'

// The one entry point: ~providers only, zero app.component (contract 01 §10). All wiring
// lives in bootstrap.ts. If boot fails (e.g. a missing env var), surface it — never mount
// silently (contract 01 §14).
bootstrap().catch((err: unknown) => {
  const message = err instanceof Error ? err.message : String(err)
  const root = document.querySelector('#app')
  if (root) {
    root.textContent = `Orphex failed to start: ${message}`
    root.setAttribute('data-boot-error', 'true')
  }
  console.error('[orphex] boot failed:', err)
})
